import styled from 'styled-components';
import { colors, ApIcon } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	overflow: auto;
	align-items: center;
`;

export const Content = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	color: ${colors.grey7};
	width: 543px;
	font-size: 16px;
	line-height: 24px;
	letter-spacing: 0.3px;
	padding-top: 80px;
`;

export const Info = styled.div`
	font-weight: 500;
	font-size: 19px;
	line-height: 27px;
	letter-spacing: initial;
	margin-bottom: 53px;
	text-align: center;
`;

export const LegalTitle = styled.div`
	font-weight: 500;
	font-size: 28px;
	line-height: 35px;
	margin-bottom: 16px;
	text-align: center;
`;

export const LegalList = styled.div`
	font-weight: bold;
	line-height: 30px;
	padding: 16px 0;
`;

export const ButtonWrapper = styled.div`
	padding: 49px 0 32px 0;
	display: flex;
	align-items: center;
	flex-direction: column;
`;

export const ErrorText = styled.div`
	color: ${colors.red2};
	display: flex;
	align-items: center;
	font-size: 13px;
	line-height: 13px;
	margin-bottom: 12px;
	letter-spacing: 0;
`;

export const StyledIcon = styled(ApIcon)`
	margin-right: 5px;
`;

export const DownloadWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`;
